import './Components.css'

function InputGroup(props) {
    return (<div className={"input-group flex-center column"} {...props}>

    </div>)
}

export default InputGroup